import axios from "axios";

export const loginApi = (data) => {
  return axios.post("https://alnabaatech.com.ly/api/auth/login", data);
};